import useSWR from 'swr';
import { getTenantName } from 'packages/lib/auth/okta';

export function useTenant() {
  return useSWR('tenant-name', getTenantName);
}
